<footer class="cov-footer mt-3 d-print-none">
  <div class="row g-0">
    <div class="col-12 col-lg-4">
      <h3 class="cov-footer-heading">{{ 'footer.legal.heading' | transloco }}</h3>
      <ul>
        @for (link of legalLinks; track link) {
          <li>
            <a
              [href]="link.href"
              [target]="link.external ? '_blank' : '_self'"
              [rel]="link.external ? 'noopener noreferrer' : null"
            >
              {{ link.key | transloco }}
            </a>
          </li>
        }
      </ul>
    </div>

    <div class="col-12 col-lg-4">
      <h3 class="cov-footer-heading">{{ 'footer.covestro.heading' | transloco }}</h3>
      <ul>
        @for (link of covestroLinks$ | async; track link) {
          <li>
            <a
              [href]="link.href"
              [target]="link.external ? '_blank' : '_self'"
              [rel]="link.external ? 'noopener noreferrer' : null"
            >
              {{ link.key | transloco }}
            </a>
          </li>
        }
      </ul>
    </div>

    <div class="col-12 col-lg-4">
      <h3 class="cov-footer-heading">{{ 'footer.contact.heading' | transloco }}</h3>
      <ul>
        @for (link of contactLinks; track link) {
          <li>
            <a
              [href]="link.href"
              [target]="link.external ? '_blank' : '_self'"
              [rel]="link.external ? 'noopener noreferrer' : null"
            >
              {{ link.key | transloco }}
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
  <div class="copyright">{{ 'footer.copyright' | transloco:{ year: copyrightYear } }}</div>
</footer>
